import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
const firebaseConfig = {
   apiKey: "AIzaSyC4KALUtPj3roBlp9M08eUt0kKhlbNOc4g",
  authDomain: "chatg-1eb8a.firebaseapp.com",
  projectId: "chatg-1eb8a",
  storageBucket: "chatg-1eb8a.appspot.com",
  messagingSenderId: "1049765742130",
  appId: "1:1049765742130:web:5619a8fd4cbecc45d49e2b",
  measurementId: "G-FK41N5H340"
};
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
